import { render, staticRenderFns } from "./ResetContent.vue?vue&type=template&id=7e761bb5&scoped=true"
import script from "./ResetContent.vue?vue&type=script&lang=js"
export * from "./ResetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e761bb5",
  null
  
)

export default component.exports